(function ($) {

    if ($('#notices-div.notices-major.reveal').length) {
        $('#notices-div.notices-major.reveal').foundation('open');
    }

    $(document).on('click', '#notices-div.notices-major .close', function () {
        $('#notices-div.notices-major.reveal').foundation('close');
        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: {
                action: 'majorNotificationCall'
            },
            success: function () {
                console.log('acknowledging notices banner clicked');
            }
        });
    });

    $(document).on('click', '#notices-div.notices-minor .close', function () {
        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: {
                action: 'minorNotificationCall'
            },
            success: function () {
                console.log('acknowledging notices banner clicked');
            }
        });
        $('#notices-div').css('display', 'none');
    });

}(jQuery));
